
  var rt = require("@stylable/runtime/cjs/css-runtime-stylesheet.js");

  module.exports = rt.create(
      "VideoPlayer34179784",
      {"classes":{"root":"VideoPlayer34179784__root","playerContainer":"VideoPlayer34179784__playerContainer","facebookContainer":"VideoPlayer34179784__facebookContainer","cover":"VideoPlayer34179784__cover","vimeoContainer":"VideoPlayer34179784__vimeoContainer"},"vars":{},"stVars":{"backgroundColor":"rgba(var(--backgroundColor, 0,0,0), var(--alpha-backgroundColor, 1))","font":"var(--font)","fontColor":"rgba(var(--fontColor, 255,255,255), var(--alpha-fontColor, 1))","borderColor":"rgba(var(--borderColor, 0,0,0), var(--alpha-borderColor, 1))","borderSize":"var(--borderSize)","boxShadow":"var(--boxShadow)","playButtonSize":"var(--playButtonSize)","playButtonMobileSize":"var(--playButtonMobileSize)","textSizeScale":"'1px'"},"keyframes":{}},
      "",
      -1,
      module.id
  );
  